import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";
import {GameInfoModulePlaceholder} from "./placeholders/game-info-module.placeholder";

const GameInfoModuleAsyncComponent = AsyncComponent(async () => import('./game-info-module' /* webpackChunkName: "game-info-module" */ ));

export const GameInfoModuleAsync = (props) => {
  return <React.Suspense fallback={<GameInfoModulePlaceholder/>}>
    <GameInfoModuleAsyncComponent {...props}/>
  </React.Suspense>
};
